import { TerminationRequestTrackingItemDto } from '../api/dto/termination-request-tracking.dto'

export const SYSTEM_ACTOR_LABEL = 'system'

type ActorRow = Pick<
  TerminationRequestTrackingItemDto,
  'actor' | 'requesterId' | 'source'
>

const isApiActor = (row: ActorRow) =>
  row.source === 'API_SYNC_AUTO_TERMS' ||
  row.requesterId === 'API_SYNC_AUTO_TERMS'

export function actorLabel(row: ActorRow): string {
  if (isApiActor(row)) {
    return SYSTEM_ACTOR_LABEL
  }
  return row.actor || row.requesterId || '—'
}

export function actorLinkId(row: ActorRow): string | null {
  if (isApiActor(row) || actorLabel(row) === '—') {
    return null
  }
  return row.requesterId || null
}
